import type { SVGProps } from 'react';

export function ChangelogIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14 10H44L52 18V54H14V10Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M44 10V18H52" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M22 28L42 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M22 36L38 36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M22 44L34 44" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
